import { type HotkeyLayer } from '@/ui/utilities/hotkey/types/HotkeyLayer';

// Esc closes the panel only when nothing is open on top of it.
export const SIDE_PANEL_HOTKEY_LAYERS: readonly HotkeyLayer[] = ['side-panel'];
